import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import CloseIcon from "../../assets/svgIcons/CloseIcon";
import StyledText from "./StyledText";
import { media } from "../../utils/helper";

const ModalStyle = styled(Modal)`
  .modal-content {
    border-radius: 4px;
    border: 0;
    box-shadow: 1px 1px 99px 0 #00000026;
    padding-bottom: 2.5rem;

    ${media.md`
      padding-top: 40px;
      position: fixed;
      bottom: ${({ show, delayedShow }) => (show && delayedShow ? "0" : "0")}; 
      left: 0;
      right: 0;
      margin: 0;
      transition: bottom 0.3s ease-in;
    `}
    .modal-body {
      display: flex;
      justify-content: center;
    }
  }
`;

const StyledModal = ({ show, onHide, children, size = "lg" }) => {
  const [delayedShow, setDelayedShow] = useState(false);

  useEffect(() => {
    let timeout;
    if (show) {
      timeout = setTimeout(() => {
        setDelayedShow(true);
      }, 100);
    }
    return () => {
      setDelayedShow(false);
      clearTimeout(timeout);
    };
  }, [show]);

  return (
    <ModalStyle
      show={show}
      onHide={onHide}
      centered
      size={size}
      delayedshow={delayedShow}
    >
      <Modal.Header className="p-0 border-0 justify-content-end">
        <StyledText
          as="span"
          className="cursor-pointer d-none d-md-block"
          onClick={onHide}
        >
          <CloseIcon />
        </StyledText>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </ModalStyle>
  );
};

export default StyledModal;
